import { HUBSPOT_WHITEPAPER_FORM_ID } from "../api/hubspot";
import WhitepaperPage from "./WhitepaperPage";

// ホワイトペーパー「個人AIから組織AIへ」のダウンロードページ（/whitepaper）。
//
// /download（契約条件の比較表）とは別物なので分けている。
// あちらは各社の規約を確認した結果の一次情報。こちらは導入の型を示す読み物で、
// 相手も目的も違う。
//
// 2本目以降の資料は /whitepaper/<資料名> に置いている。これだけ /whitepaper
// 直下なのは先に公開したため。広告やリンクが向いているので動かしていない。
//
// 原本は Google スライド（ホワイトペーパー_組織AI_260908）。
// 更新したらPDFを書き出し直し、public/downloads/ と
// public/images/whitepaper/ の紙面画像を両方入れ替えること。

function AiAdoptionWhitepaper() {
  return (
    <WhitepaperPage
      formId={HUBSPOT_WHITEPAPER_FORM_ID}
      leadKind="whitepaper"
      title="個人AIから組織AIへ"
      lead="属人化を防ぎ、全社でAIを使いこなす5つの実践ステップ。個人の活用が組織の成果に繋がらない理由と、その手当てをまとめています。フォーム送信後、すぐにダウンロードいただけます。"
      pdfHref="/downloads/leaps-whitepaper-organization-ai.pdf"
      spec="全12ページ ／ PDF"
      cover="/images/whitepaper/slide-1.png"
      inside={[
        { src: "/images/whitepaper/slide-4.png", cap: "5つの要素" },
        { src: "/images/whitepaper/slide-5.png", cap: "実践ステップ" },
        { src: "/images/whitepaper/slide-10.png", cap: "セルフチェック" },
      ]}
      // 中身の要点。抽象的な効能ではなく、資料が実際に扱っている項目を出す。
      topics={[
        "個人のAI活用が、組織の成果に繋がらない構造",
        "属人化・再現性・データ・ナレッジ・コストの5つの症状",
        "整えるべき5要素と、それぞれの実践ステップ",
        "5項目の簡易セルフチェック",
      ]}
    />
  );
}

export default AiAdoptionWhitepaper;
